export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
export const AD_SLOTS = {
  search: process.env.REACT_APP_ADSENSE_SLOT_SEARCH || "",
  recipe: process.env.REACT_APP_ADSENSE_SLOT_RECIPE || "",
};

let scriptPromise;

export function loadAdSense() {
  if (!ADSENSE_CLIENT) return Promise.reject(new Error("AdSense client not configured"));
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.async = true;
    s.crossOrigin = "anonymous";
    s.dataset.adsenseLoader = "true";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(ADSENSE_CLIENT)}`;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Unable to load AdSense"));
    document.head.appendChild(s);
  });
  return scriptPromise;
}
